import React from "react";
import { Link } from "react-router-dom";
import '../../style_new.css';


const Navbar = () => {
  return (
    
    <>
      <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top px-4 px-lg-5 py-lg-0">
      <Link to="/" className="navbar-brand d-flex align-items-center">
          <img
            src={'./images/fairvisionlogo.jpg'}
            alt="Fair Vision Ventures"
            style={{ height: "50px",width:'50px', marginRight: "10px" }}
          />
          <h1 className="m-0 d-none d-lg-block">
           
            FAIR VISION VENTURES
          </h1>
        </Link>
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav ms-auto py-3 py-lg-0">
            <Link to="/" class="nav-item nav-link active">Home</Link>
            <Link to="/about-us" class="nav-item nav-link">About</Link>
            <Link to="/our-services" class="nav-item nav-link">Our Services</Link>
            {/* <Link to="/features-page" class="nav-item nav-link">Features</Link> */}
            <Link to="/contact-us"class="nav-item nav-link">Contact Us</Link>
          </div>
        </div>
      </nav>
    </>
  );
};
  
export default Navbar;